import { fetcher } from "helpers/fetcher";

import {
  TGetJobListingWorkingHoursReq,
  TGetJobListingWorkingHoursRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getJobListingWorkingHours = async (
  params?: TGetJobListingWorkingHoursReq
) => {
  return await fetcher<
    TGetJobListingWorkingHoursRes,
    TGetJobListingWorkingHoursReq["data"]
  >(ENDPOINT.CORPORATION.GET_JOB_LISTING_WORKING_HOURS, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_JOB_LISTING_WORKING_HOURS.version,
    },
  });
};

export const queryGetJobListingWorkingHours = async (
  params?: TGetJobListingWorkingHoursReq
) => {
  return (await getJobListingWorkingHours(params)).data;
};

queryGetJobListingWorkingHours._key = (
  params?: TGetJobListingWorkingHoursReq,
  key?: number
) => [ENDPOINT.CORPORATION.GET_JOB_LISTING_WORKING_HOURS.url, params, key];
